import {
  SET_BANNERS,
  BANNER_ERROR,
  CREATE_BANNER,
  DELETE_BANNER,
} from "../actions/banner";

const initialState = {
  banners: [],
  error: null,
};

const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BANNERS:
      return {
        ...state,
        banners: action.data,
        error: null,
      };
    case BANNER_ERROR:
      return {
        ...state,
        error: action.data,
      };
    case CREATE_BANNER:
      return {
        ...state,
        banners: [...state.banners, action.data],
        error: null,
      };
    case DELETE_BANNER:
      return {
        ...state,
        banners: state.banners.filter((banner) => banner.id !== action.data),
        error: null,
      };
    default:
      return state;
  }
};

export default bannerReducer;
